export default {
  'common.openDataLab': 'OpenDataLab',
  'common.formatted': 'Formatted',
  'common.original': 'Original',
  'common.finish': 'Finish',
  'common.submit': 'Submit',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.reset': 'Reset',
  'common.totalItems': 'Total {num} items',
  'common.operate': 'Operate',
  'common.download': 'Download',
  'common.other': 'Other',
  'common.all': 'All',
  'common.all.xlab': '{num} Datasets',
  'common.delete': 'Delete',
  'common.top': 'TOP',
  'common.filter': 'Filter',
  'common.404': 'Sorry, the page you visited does not exist.',
  'common.backHome': 'Back Home',
  'common.edit': 'Edit',
  'common.preview': 'Preview',
  'common.code': 'Code',
  'common.clear': 'Clear',
  // v1.9.0
  'common.basic': 'Basic Info',
  'common.email': 'Email',
  'common.phone': 'Phone',
  'common.github': 'GitHub ID',
  'common.pw': 'Password',
  'common.otherInfo': 'Others',
  'common.username': 'UserName',
  'common.org': 'Organization/Company',
  'common.weChat': 'WeChat',
  'common.zhihu': 'ZhiHu',
  'common.save': 'Save',
  'common.copy': 'Copy',
  'common.copySuccess': 'copy successfully',
  'common.loadMore': 'Load more',
  'common.noData': 'No Data',
  'common.prev': 'Prev',
  'common.next': 'Next',
  'common.enter': 'Please enter',
  'common.select': 'Please select',
  'common.status': 'Status',
  'common.know': 'I got it',
  'common.desc': 'Description',
  'common.quit': 'Quit',
  'common.home.all': 'All {num} Datasets',
  'common.login': 'Login',

  // 冰山之下的数据集；
  'common.iceberg': 'Explore rare data',

  'common.type': 'Type',
  'common.organization': 'Org',
  'common.stayTuned': 'Stay Tuned',

  // law
  'common.datasets.use.title': 'Disclaimer',
  'common.datasets.use.law':
    'Respect originality, unauthorized bulk transfer will bear legal responsibility. If you have any cooperation intention, please contact {slot}.',
  'common.online.explore': 'Online Explore',
  'common.local.deploy': 'Local Deployment',
  //error
  'common.datasets.notFound': 'The dataset does not exist',
  'common.datasets.notFound.try': 'Try other datasets.～',
  'common.datasets.notFound.back': 'Return to the homepage.',
  'common.expand': 'Expand',
  'common.collapse': 'Collapse',
  'common.upload.text': 'Uploading, please wait patiently',
  'common.submit.success': 'Submit successfully',
  'common.mobile.noAccess': 'Not supported mobile. Please use desktop version.'
};
